import { getLogger } from '@packages/core/logging';

import type { WorksheetCaseGroupEntity } from '../entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { toWorksheetCaseGroupEntity } from '../helpers';

const logger = getLogger('worksheets.groups');

/** Parameters for fetching available worksheet titles. */
export type FetchTitlesParams = {
    /** Whether the current user is a pilot user, which affects which worksheets are visible. */
    isPilotUser: boolean;

    /** An optional abort signal for cancelling the request. */
    signal?: AbortSignal;
};

/**
 * Fetches available worksheet titles for given case types and model year.
 * Used to populate the worksheet selection list.
 */
export class FetchTitles extends StsBackendOperation {
    /**
     * Fetch worksheet titles filtered by pilot user status and map to domain entities.
     *
     * @param params - the filter criteria and request options
     * @returns the worksheet case group entities, or undefined if the fetch fails or is aborted
     */
    async exec(params: FetchTitlesParams): Promise<WorksheetCaseGroupEntity[] | undefined> {
        try {
            const response = await this.client.getWorksheetTitles({ isPilotUser: params.isPilotUser }, params.signal);

            if (!response.success) {
                return undefined;
            }

            return response.data.map(toWorksheetCaseGroupEntity);
        } catch (e) {
            logger.error('Failed to fetch the worksheet titles', { error: e });
        }
    }
}
